import { render, staticRenderFns } from "./AccessPointTabs.vue?vue&type=template&id=478ea515&scoped=true"
import script from "./AccessPointTabs.vue?vue&type=script&lang=js"
export * from "./AccessPointTabs.vue?vue&type=script&lang=js"
import style0 from "./AccessPointTabs.vue?vue&type=style&index=0&id=478ea515&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ea515",
  null
  
)

export default component.exports